import React, { useEffect } from 'react';
import M from 'materialize-css';
import  './corpo.css';

function PageCorpo() {
  useEffect(() => {
    M.Modal.init(document.querySelectorAll('.modal'), {});
    M.Collapsible.init(document.querySelectorAll('.collapsible.procedimentos'), {});
  }, []);

  const procedimentos = [
    {
      id: 'modal-abdominoplastia',
      titulo: 'Abdominoplastia',
      descricao: 'Redefinição do abdômen com harmonia',
      imagem: '/images/procedimentos/abdominoplastia.png',
      modalContent: {
        titulo: 'Abdominoplastia',
        descricao: 'A abdominoplastia é uma cirurgia plástica que remove o excesso de pele e gordura do abdômen, além de corrigir a flacidez muscular. Indicada para pacientes que desejam um contorno abdominal mais firme e definido, especialmente após grandes perdas de peso ou gestação, a técnica proporciona resultados naturais e duradouros. Durante o procedimento, as cicatrizes são posicionadas estrategicamente para ficarem discretas, geralmente abaixo da linha das roupas íntimas e dentro do umbigo, que também costuma ser discreta. A cirurgia pode ser combinada com outras técnicas, como lipoaspiração, para resultados ainda mais completos.',
        perguntas: [
          {
            pergunta: 'Quem pode fazer abdominoplastia?',
            resposta: 'Pessoas com excesso de pele ou flacidez abdominal que desejam melhorar o contorno corporal.'
          },
          {
            pergunta: 'Existe algum risco nessa cirurgia?',
            resposta: 'Como qualquer procedimento cirúrgico, existem riscos como infecções, trombose, cicatrizes anormais e acúmulo de líquidos, mas esses são minimizados com acompanhamento médico.'
          },
          {
            pergunta: 'Quanto tempo dura a recuperação?',
            resposta: 'A recuperação inicial, na qual a paciente precisará andar curvada e dormir com as pernas e as costas elevadas, leva cerca de 2 a 3 semanas, com retorno gradual à postura normal e às atividades cotidianas.'
          },
          {
            pergunta: 'É necessário usar a cinta compressiva?',
            resposta: 'Sim. Por 30 a 60 dias, a depender da sua recuperação. A cinta, desde que usada de forma adequada, ajuda a controlar o inchaço e a garantir uma boa cicatrização.'
          },
          {
            pergunta: 'Qual é a previsão de retorno às atividades físicas esportivas?',
            resposta: 'Normalmente a paciente se sente segura para atividades de baixo impacto, e que não exijam muito esforço, após 4 semanas. Se programe para atividades mais intensas a partir de 2 a 3 meses.'
          }
        ]
      }
    },
    {
      id: 'modal-miniabdomino',
      titulo: 'Mini abdominoplastia',
      descricao: 'Solução para flacidez leve no abdômen',
      imagem: '/images/procedimentos/miniabdominoplastia.png',
      modalContent: {
        titulo: 'Mini abdominoplastia',
        descricao: 'A mini abdominoplastia é uma cirurgia plástica indicada para corrigir flacidez leve e excesso de pele localizado na parte inferior do abdômen. Ideal para pacientes que apresentam pequenas alterações na região abaixo do umbigo, a técnica oferece resultados naturais e cicatrizes menores. Durante o procedimento, a cicatriz é posicionada estrategicamente na linha das roupas íntimas, e o umbigo geralmente não é reposicionado. A mini abdominoplastia pode ser combinada com lipoaspiração para potencializar o contorno corporal.',
        perguntas: [
          {
            pergunta: 'Quem pode fazer mini abdominoplastia?',
            resposta: 'Pacientes com excesso de pele ou flacidez leve no abdômen inferior.'
          },
          {
            pergunta: 'As cicatrizes são visíveis?',
            resposta: 'São discretas e ficam posicionadas abaixo da linha das roupas íntimas.'
          },
          {
            pergunta: 'Quanto tempo dura a recuperação?',
            resposta: 'A recuperação inicial leva cerca de 1 a 2 semanas, com retorno gradual às atividades cotidianas, sem esforços físicos.'
          },
          {
            pergunta: 'A cirurgia envolve reposição do umbigo?',
            resposta: 'Não. O umbigo normalmente não é reposicionado na mini abdominoplastia.'
          },
          {
            pergunta: 'Os resultados são permanentes?',
            resposta: 'Sim, desde que o paciente mantenha um peso estável e estilo de vida saudável.'
          }
        ]
      }
    },
    {
      id: 'modal-lipo',
      titulo: 'Lipoaspiração',
      descricao: 'Remodelando o contorno corporal',
      imagem: '/images/procedimentos/lipoaspiracao.png',
      modalContent: {
        titulo: 'Lipoaspiração',
        descricao: 'A lipoaspiração é uma cirurgia plástica que remove depósitos de gordura localizada, proporcionando um contorno corporal mais definido. Indicada para pacientes que desejam melhorar áreas específicas, como abdômen, flancos, coxas ou braços, a técnica pode ser realizada de forma tradicional ou com tecnologias avançadas como Laser OneStep ou VASER. Cada método tem suas particularidades, sendo escolhido conforme as necessidades do paciente e a avaliação médica. As cicatrizes são pequenas e discretas, localizadas em pontos estratégicos.',
        perguntas: [
          {
            pergunta: 'Quem pode fazer lipoaspiração?',
            resposta: 'Pacientes com gordura localizada que desejam melhorar o contorno corporal.'
          },
          {
            pergunta: 'As cicatrizes são visíveis?',
            resposta: 'Não. As cicatrizes são pequenas e ficam em áreas pouco perceptíveis.'
          },
          {
            pergunta: 'Quanto tempo dura a recuperação?',
            resposta: 'A recuperação inicial leva de 7 a 14 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.'
          },
          {
            pergunta: 'Os resultados são permanentes?',
            resposta: 'Sim, desde que o paciente mantenha um peso estável e hábitos saudáveis.'
          },
          {
            pergunta: 'Quais áreas podem ser tratadas?',
            resposta: 'Abdômen, flancos, coxas, braços, costas e outras regiões com gordura localizada.'
          }
        ]
      }
    },
    {
      id: 'modal-lipoescultura',
      titulo: 'Lipoescultura',
      descricao: 'Redefinindo o corpo com naturalidade',
      imagem: '/images/procedimentos/lipoescultura.png',
      modalContent: {
        titulo: 'Lipoescultura',
        descricao: 'A lipoescultura é uma cirurgia plástica que combina a remoção de gordura localizada por lipoaspiração com o enxerto dessa gordura em outras áreas do corpo, como glúteos, para melhorar o contorno corporal. Indicada para pacientes que desejam uma silhueta mais harmoniosa, a técnica utiliza a gordura do próprio corpo para resultados naturais. A cirurgia é planejada de forma personalizada, considerando as necessidades e objetivos de cada paciente. As cicatrizes são pequenas e discretas, localizadas estrategicamente para ficarem pouco visíveis.',
        perguntas: [
          {
            pergunta: 'Quem pode fazer lipoescultura?',
            resposta: 'Pacientes com gordura localizada que desejam melhorar o contorno corporal e preencher áreas específicas.'
          },
          {
            pergunta: 'As cicatrizes são visíveis?',
            resposta: 'Não. Elas são pequenas e ficam posicionadas em locais discretos.'
          },
          {
            pergunta: 'Quanto tempo dura a recuperação?',
            resposta: 'A recuperação inicial leva de 10 a 14 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.'
          },
          {
            pergunta: 'Os resultados são permanentes?',
            resposta: 'Sim, desde que o paciente mantenha um peso estável e hábitos saudáveis.'
          },
          {
            pergunta: 'Quais áreas podem ser tratadas?',
            resposta: 'Glúteos, abdômen, flancos, coxas e outras regiões, conforme a avaliação médica.'
          }
        ]
      }
    },
    {
      id: 'modal-enxertoGluteo',
      titulo: 'Enxerto de Glúteo',
      descricao: 'Volume e definição com gordura própria',
      imagem: '/images/procedimentos/gluteoplastia.png',
      modalContent: {
        titulo: 'Enxerto Glúteo',
        descricao: 'O enxerto de glúteo, também conhecido como gluteoplastia de aumento com gordura, é uma técnica que utiliza gordura retirada de outras partes do corpo para aumentar e modelar os glúteos. Ideal para pacientes que desejam um contorno mais volumoso e harmônico, o procedimento proporciona resultados naturais e seguros. A gordura é coletada por lipoaspiração, processada e injetada estrategicamente nos glúteos para alcançar o formato desejado. As cicatrizes são pequenas e posicionadas em locais discretos, garantindo um excelente resultado estético.',
        perguntas: [
          {
            pergunta: 'Quem pode fazer enxerto de glúteo?',
            resposta: 'Pacientes com gordura localizada e desejo de aumentar o volume e definir os glúteos.'
          },
          {
            pergunta: 'As cicatrizes são visíveis?',
            resposta: 'Não. Elas são pequenas e ficam em áreas pouco perceptíveis.'
          },
          {
            pergunta: 'Quanto tempo dura a recuperação?',
            resposta: 'A recuperação inicial leva de 2 a 3 semanas, com retorno gradual às atividades do cotidiano, sem esforços físicos.'
          },
          {
            pergunta: 'Os resultados são permanentes?',
            resposta: 'Em parte. Uma fração da gordura é reabsorvida pelo corpo, mas o volume restante é duradouro.'
          },
          {
            pergunta: 'É necessário repetir o procedimento?',
            resposta: 'Depende do caso. Em algumas situações, pode ser necessário um retoque para otimizar os resultados.'
          }
        ]
      }
    },
    {
      id: 'modal-protesePant',
      titulo: 'Próteses de Panturrilhas',
      descricao: 'Definição para as pernas',
      imagem: '/images/procedimentos/panturrilhas.png',
      modalContent: {
        titulo: 'Próteses de Panturrilhas',
        descricao: 'A prótese de panturrilha é uma cirurgia plástica que utiliza implantes de silicone para aumentar o volume e melhorar o contorno das panturrilhas. Indicada para pacientes que desejam corrigir assimetrias, realçar a musculatura ou melhorar a proporção das pernas, a técnica proporciona resultados naturais e equilibrados. Os implantes são posicionados por meio de pequenas incisões na região posterior do joelho, garantindo cicatrizes discretas. A escolha do formato e tamanho é feita de forma personalizada, considerando as necessidades de cada paciente.',
        perguntas: [
          {
            pergunta: 'Quem pode fazer prótese de panturrilha?',
            resposta: 'Pacientes com panturrilhas pequenas ou assimétricas que desejam maior volume e definição.'
          },
          {
            pergunta: 'As cicatrizes são visíveis?',
            resposta: 'Sim. Elas ficam localizadas em dobras naturais atrás do joelho, tornando-se pouco perceptíveis ao longo do tempo.'
          },
          {
            pergunta: 'Quanto tempo dura a recuperação?',
            resposta: 'A recuperação inicial leva de 2 a 3 semanas, com retorno gradual às atividades do cotidiano, sem esforços físicos.'
          },
          {
            pergunta: 'Os resultados são permanentes?',
            resposta: 'Sim, os implantes oferecem resultados duradouros e estáveis ao longo do tempo.'
          },
          {
            pergunta: 'É possível combinar com outros procedimentos?',
            resposta: 'Sim, a prótese de panturrilha pode ser combinada com outras cirurgias para resultados mais completos.'
          }
        ]
      }
    }
  ];

  return (
    <div>
      <div>
        <h3 className="titulo-cirurgias-page-corpo">
          Corpo
        </h3>
      </div>
      

      {procedimentos.map((procedimento, index) => (
        <div key={index} className="row-page-corpo" id={`containerProcedimentosText${index % 2 === 0 ? 'Right' : 'Left'}`} >
          <div className="col-page-corpo s12">
            <div className={`hoverable container-page-corpo ${index % 2 === 0 ? 'even' : 'odd'}`}>
              <div className='image-container-page-corpo'>
                <img
                  src={procedimento.imagem}
                  alt={procedimento.titulo}
                />
              </div>
              <div className={`text-container-page-corpo ${index % 2 === 0 ? 'right' : 'left'}`}>
                <h5 className='card-title-page-corpo'>{procedimento.titulo}</h5>
                <p className='card-description-page-corpo'>{procedimento.descricao}</p>
                <a className="modal-trigger custom-btn" href={`#${procedimento.id}`}>
                  Saiba mais
                </a>
              </div>
            </div>
          </div>

          <div id={procedimento.id} className="modal">
          <a href="#!" className="modal-close btn-close-icon">
    <i className="material-icons">close</i>
          </a>
            <div className="modal-content-page-corpo">
              <h4 className='modal-title-page-corpo'>{procedimento.modalContent.titulo}</h4>
              <p className='modal-description-page-corpo'>{procedimento.modalContent.descricao}</p>
              <h5 className='questions-title-page-corpo'>Dúvidas Frequentes</h5>
              <ul className="collapsible procedimentos">
                {procedimento.modalContent.perguntas.map((pergunta, idx) => (
                  <li key={idx}>
                    <div className="collapsible-header procedimentos-header-page-corpo">
                      {pergunta.pergunta}
                      <i className="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div className="collapsible-body procedimentos-body-page-corpo">
                      <p className='question-page-corpo'>{pergunta.resposta}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default PageCorpo;